import { useConnectionStore } from '../stores/connectionStore';
import { useRouter } from 'vue-router';
import axios from "axios";

const contaboVerbalWebsiteURL = "https://www.verbalchess.fun/"

const contaboWebsiteURL = "https://www.chessvis.com/"
const developmentWebsiteURL = "http://chessvis.ddns.net:8888/"
//const websiteURL = "http://192.168.1.11/"

export function getWebSiteURL() {
  const websiteURL = (process.env.NODE_ENV === 'production') ? contaboWebsiteURL : developmentWebsiteURL
  
  // FORCE PRODUCTION
  return (contaboWebsiteURL)
  //return (websiteURL)
}

export function useGetData(programName, fieldData, processJsonResponse) {

  const connectionStore = useConnectionStore()  
  const useVerbalWebsite = connectionStore.getUseVerbalWebsite

  const websiteURL = getWebSiteURL()

  //console.log("website  ",websiteURL)

  const URL = (useVerbalWebsite) ? contaboVerbalWebsiteURL + "redirect.php" : getWebSiteURL() + programName

  // convert the POST data from the calling program into a JSON object.
  // then add the "builtins" - cookie, dummy, calltype and platform (cook = 4) which is the "web"

  var postData = JSON.parse(JSON.stringify(fieldData))

  const cookie = connectionStore.getCookie
  const dummy = connectionStore.getDummy

  /*
  if (process.env.NODE_ENV !== 'production') {
    console.log("############### COOKIE IS HARDCODED")
    cookie = "$2y$10$foyP6pBVtKcn/3aFiEQJneJdqveHulH3Xqzocxyh0dwmT85OE7456"
    dummy = 0
  }
  */

  if (useVerbalWebsite)
    postData.actual_program = programName
  postData.cookie = cookie
  postData.dummyUser = dummy
  postData.calltype = "2"
  postData.cook = "7"           // 1=old web, 2=ios, 3=android, 4=new web

  //console.log("**** postdata for program ",programName,postData)

  var controller = null
  var optionAxios = {
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    }
  }

  if (postData.hasOwnProperty('enableAbort')) {
    //console.log("enable abort")
    controller = new AbortController()
    optionAxios.signal = controller.signal
  }

  axios.post(URL,postData,optionAxios)
    .then(
      response => {

        // this shows the JSON coming back from the server
        //console.log(response)

        //console.log("**** after response data.  cookie ",cookie)

        // check the cookie before going back to the calling routine
        if (cookie == "") {
          //console.log("in new cookie")
          const jsonCookie = response.data.hasOwnProperty("cookie") ? response.data['cookie'] : null
          const jsonDummy = response.data.hasOwnProperty("dummy") ? response.data['dummy'] : null
          //console.log("before if", jsonCookie, jsonDummy)
          if (jsonCookie != null && jsonDummy != null) {
            connectionStore.setUserCookieDummy(jsonCookie,jsonDummy)            
          }
        }
        //console.log("In Getdata good data")
        if (processJsonResponse != null)
          processJsonResponse(response.data);
      }
    )
    .catch(error => {
      const errorJson = { "error" : error , "programRun" : programName}
      //console.log("In Getdata error -> ",errorJson)
      if (processJsonResponse != null)
        processJsonResponse(errorJson);
    })
  //console.log("****** END OF GETDATA", controller)
  return (controller)
}

export function doAxiosAbort(controller) {
  if (controller != null) {
    //console.log("AXIOS ABORT")
    controller.abort()
  }
}

// special getdata for use by startup because it will have a callback into the initiating routine
export function useGetDataStartup(programName, fieldData, processJsonResponse,afterProcessingCallbackRoutine) {

  const connectionStore = useConnectionStore()
  const useVerbalWebsite = connectionStore.getUseVerbalWebsite


  //console.log("website  ",websiteURL)

  const URL = (useVerbalWebsite) ? contaboVerbalWebsiteURL + "redirect.php" : getWebSiteURL() + programName

  // convert the POST data from the calling program into a JSON object.
  // then add the "builtins" - cookie, dummy, calltype and platform (cook = 4) which is the "web"

  var postData = JSON.parse(JSON.stringify(fieldData))

  const cookie = connectionStore.getCookie
  const dummy = connectionStore.getDummy

  if (useVerbalWebsite)
    postData.actual_program = programName
  postData.cookie = cookie
  postData.dummyUser = dummy
  postData.calltype = "2"
  postData.cook = "7"           // 1=old web, 2=ios, 3=android, 4=new web,
                                // 5=ios verbal, 6=android verbal, 7=web verbal

  //console.log("**** postdata in startup ",postData)
  var optionAxios = {
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    }
  }
  axios.post(URL,postData,optionAxios)
    .then(
      response => {

        // this shows the JSON coming back from the server
        //console.log("********* response in startup",response)

        //console.log("**** after response data.  cookie ",cookie)

        // check the cookie before going back to the calling routine
        if (cookie == "") {
          //console.log("in new cookie")
          const jsonCookie = response.data.hasOwnProperty("cookie") ? response.data['cookie'] : null
          const jsonDummy = response.data.hasOwnProperty("dummy") ? response.data['dummy'] : null
          //console.log("before if", jsonCookie, jsonDummy)
          if (jsonCookie != null && jsonDummy != null) {
            connectionStore.setUserCookieDummy(jsonCookie,jsonDummy)            
          }
        }
        //console.log("In Getdata for startup routine")
        processJsonResponse(response.data,afterProcessingCallbackRoutine);
      }
    )
    .catch(error => {
      const errorJson = { "error" : error , "programRun" : programName}
      //console.log("In Getdata error -> ",errorJson)
      processJsonResponse(errorJson,afterProcessingCallbackRoutine);
    })
}

// https://stackoverflow.com/questions/5684303/javascript-window-open-pass-values-using-post

export function useGetDataDownload(programName, fieldData) {

  const websiteURL = getWebSiteURL()

  //console.log("website  ",websiteURL)

  const URL = websiteURL + programName
  //window.open(URL)

  // convert the POST data from the calling program into a JSON object.
  // then add the "builtins" - cookie, dummy, calltype and platform (cook = 4) which is the "web"

  var postData = JSON.parse(JSON.stringify(fieldData))

  const connectionStore = useConnectionStore()
  const cookie = connectionStore.getCookie
  const dummy = connectionStore.getDummy

  postData.cookie = cookie
  postData.dummyUser = dummy
  postData.calltype = "2"
  postData.cook = "7"           // 1=old web, 2=ios, 3=android, 4=new web

  var form = document.createElement("form");
  form.target = "_blank";
  form.method = "POST";
  form.action = URL;
  form.style.display = "none";

  for (var key in postData) {
      var input = document.createElement("input");
      input.type = "hidden";
      input.name = key;
      input.value = postData[key];
      form.appendChild(input);
  }

  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);

}

// set fieldData to null for a "get" call

export function getLichessData(lichessURL, accessToken,fieldData, processJsonResponse) {

  //const accessToken1 = "lip_J07IAf4R0NUi2viunntt"

  //console.log("**** access token",accessToken)

  var optionAxios = {
    headers: {
        'Accept' : 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded'
    }
  }

  // some calls like to see if the token is valid don't need a Bearer Token
  
  if (accessToken != null)
    optionAxios.headers.Authorization = "Bearer " + accessToken

  // if fieldData is set to null then do a "GET"

  if (fieldData == null) {
    //console.log("######## GET call")
    axios.get(lichessURL,optionAxios)
    .then(
      response => {

        // this shows the JSON coming back from the server
        //console.log("JSON back from Lichess",response)
        processJsonResponse(response.data);
      }
    )
    .catch(error => {
      const errorJson = { "error" : error , "programRun" : lichessURL}
      //console.log("In getLichess error -> ",errorJson)
      processJsonResponse(errorJson);
    })
  }
  else {
    // convert the POST data from the calling program into a JSON object.
    var postData = JSON.parse(JSON.stringify(fieldData))

    //console.log("**** postdata ",postData)

    axios.post(lichessURL,postData,optionAxios)
      .then(
        response => {

          // this shows the JSON coming back from the server
          //console.log("JSON back from Lichess",response)
          processJsonResponse(response.data);
        }
      )
      .catch(error => {
        const errorJson = { "error" : error , "programRun" : lichessURL}
        //console.log("In getLichess error -> ",errorJson)
        processJsonResponse(errorJson);
      })
  }
}

export function getURLContents(URL, processHtmlResponse) {
    axios.get(URL)
    .then(
      response => {
        processHtmlResponse(response.data);
      }
    )
    .catch(error => {
      console.log("In getURL error -> ",error)
    })
}

// send error to server but don't prcoess response for fear of infinite loop
export function generateErrorAlertText(json) {
  const text = "ERROR while running -> " + json['programRun'] + "\n\n" + json['error']
                  + "\n\n" + "*** PLEASE send this message to henry@chessvis.com"

  var formData = {
    error_text : text
  }
  //useGetData("set_verbal_error.php", formData, null)

  return (text)
}

export function Utf8ArrayToStr(array) {
    var out, i, len, c;
    var char2, char3;

    out = "";
    len = array.length;
    i = 0;
    while(i < len) {
    c = array[i++];
    switch(c >> 4)
    { 
      case 0: case 1: case 2: case 3: case 4: case 5: case 6: case 7:
        // 0xxxxxxx
        out += String.fromCharCode(c);
        break;
      case 12: case 13:
        // 110x xxxx   10xx xxxx
        char2 = array[i++];
        out += String.fromCharCode(((c & 0x1F) << 6) | (char2 & 0x3F));
        break;
      case 14:
        // 1110 xxxx  10xx xxxx  10xx xxxx
        char2 = array[i++];
        char3 = array[i++];
        out += String.fromCharCode(((c & 0x0F) << 12) |
                       ((char2 & 0x3F) << 6) |
                       ((char3 & 0x3F) << 0));
        break;
      }
    }
    return out;
  }